/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoCarousel_user = {
    readonly serviceId: string | null;
    readonly " $refType": "SbRespInteriorsPhotoCarousel_user";
};
export type SbRespInteriorsPhotoCarousel_user$data = SbRespInteriorsPhotoCarousel_user;
export type SbRespInteriorsPhotoCarousel_user$key = {
    readonly " $data"?: SbRespInteriorsPhotoCarousel_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoCarousel_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '9486304afdd45dc5271eadc234e5779d';
export default node;
